const DEFAULT_API_ROOT = 'https://www.stratitude.co.za/api'

export const API_ROOT = String(process.env.VUE_APP_SHARE_API_ROOT || DEFAULT_API_ROOT).replace(/\/$/, '')
export const OTP_URL = API_ROOT + '/stratitude_share_otp.php'
export const UPLOAD_URL = API_ROOT + '/stratitude_share_upload.php'
export const DOWNLOAD_URL = API_ROOT + '/stratitude_share_download.php'
export const ACTIVITY_URL = API_ROOT + '/stratitude_share_activity.php'
export const STAFF_DOMAIN = '@stratitude.co.za'
